import { useEffect } from 'react';

import { GizmoHelper, GizmoViewport, Line, OrbitControls } from '@react-three/drei';
import { Canvas, useThree } from '@react-three/fiber';
import * as THREE from 'three';

import { black02, green04 } from '../../theme.ts';
import { CoordinateSystem } from '../workspace/scene/CoordinateSystem.tsx';
import CustomGrid from '../workspace/scene/CustomGrid.tsx';
import { Lighting } from '../workspace/scene/Lighting.tsx';

export function SimpleScene() {
  const cameraPosition: [number, number, number] = [0, 0, 70];
  const fov = 70;

  function BackgroundColor() {
    const { scene } = useThree();

    useEffect(() => {
      scene.background = new THREE.Color(black02);
    }, [scene]);

    return null;
  }

  const AXIS_LENGTH = 40.0;

  function CustomAxesGizmo() {
    const lineProps = {
      lineWidth: 5,
      renderOrder: 1,
    };

    const DashedLine = ({
      start,
      end,
      color,
    }: {
      start: [number, number, number];
      end: [number, number, number];
      color: string;
    }) => <Line points={[start, end]} color={color} dashed={true} dashScale={0.05} {...lineProps} lineWidth={1.5} />;

    return (
      <group scale={[1, 1, 1]}>
        <DashedLine start={[-AXIS_LENGTH / 4, 0, 0]} end={[-AXIS_LENGTH, 0, 0]} color={green04} />
        <DashedLine start={[0, -AXIS_LENGTH / 4, 0]} end={[0, -AXIS_LENGTH, 0]} color={green04} />
        <DashedLine start={[0, 0, -AXIS_LENGTH / 4]} end={[0, 0, -AXIS_LENGTH]} color={green04} />
      </group>
    );
  }

  return (
    <Canvas
      camera={{ position: cameraPosition, fov }}
      gl={{
        antialias: true,
        alpha: false,
      }}
      style={{
        background: 'transparent',
        width: '100%',
        height: '100%',
        display: 'block',
      }}
    >
      <BackgroundColor />
      <CustomGrid />

      <GizmoHelper alignment="bottom-left" margin={[80, 80]}>
        <GizmoViewport hideNegativeAxes={true} axisColors={['#ADFF2F', '#ADFF2F', '#ADFF2F']} axisHeadScale={0.8} />
        <CustomAxesGizmo />
      </GizmoHelper>

      <Lighting />

      <CoordinateSystem />

      <OrbitControls
        makeDefault
        dampingFactor={0.02}
        maxDistance={200}
        minDistance={5}
        enableDamping={false}
        rotateSpeed={0.6}
        enableZoom={true}
        zoomSpeed={1.0}
      />
    </Canvas>
  );
}
